















































import Vue, { PropType } from 'vue'
import { StoreSalesGoods } from '@/types/generated/graphql'
import XButton from '@/components/atoms/Button/XButton.vue'
import QuantityInput from '@/components/molecules/FfGoods/QuantityInput.vue'
import XPrice from '@/components/atoms/Price/XPrice.vue'

export default Vue.extend({
  name: 'FfGoodsItem',
  components: { XButton, QuantityInput, XPrice },
  data() {
    return {
      quantity: this.value,
    }
  },
  props: {
    salesFfGoods: {
      type: Object as PropType<StoreSalesGoods>,
      required: true,
    },
    canOrder: {
      type: Boolean,
      required: true,
    },
    value: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    onOrderClicked(salesFfGoods: StoreSalesGoods) {
      this.$emit('order', salesFfGoods)
    },
    onClickGoods(salesFfGoods: StoreSalesGoods) {
      this.$router.push({
        name: 'FfGoodsDetail',
        params: {
          id: salesFfGoods.product.goodsSpecId,
          fulfillmentProcessId: salesFfGoods.fulfillmentProcessId,
        },
      })
    },
  },
  watch: {
    value() {
      this.quantity = this.value
    },
    quantity() {
      this.$emit('input', this.quantity)
    },
  },
})
